import React from 'react';
import { ENGAGEMENT_TEAM_ROLES } from '@rd-web-markets/market/dist/constants';
import { useTranslation } from 'react-i18next';
import { Form, Table } from 'react-bootstrap';
export default function ClaimGroupUserAccessForm(_ref) {
  let {
    clientContact,
    setClientContact
  } = _ref;
  const roles = ENGAGEMENT_TEAM_ROLES;
  const {
    t
  } = useTranslation();
  const handleChange = e => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setClientContact({
      ...clientContact,
      [e.target.name]: value
    });
  };
  const handleIncludeEngagementTeam = event => {
    setClientContact({
      ...clientContact,
      included_in_engagement_team: event.target.checked
    });
  };
  const handleAddRole = event => {
    const roles = clientContact.roles;
    if (event.target.checked) {
      roles.push(event.target.value);
      setClientContact({
        ...clientContact,
        roles: roles
      });
    } else {
      setClientContact({
        ...clientContact,
        roles: roles.filter(role => role !== event.target.value)
      });
    }
  };
  return /*#__PURE__*/React.createElement(Table, {
    className: "table-bordered"
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    checked: clientContact.dashboard_access,
    value: clientContact.dashboard_access,
    name: "dashboard_access",
    label: t('access_to_company_dashboard'),
    className: "ms-2",
    onChange: handleChange
  }), /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    checked: clientContact.included_in_engagement_team,
    value: clientContact.included_in_engagement_team,
    name: "included_in_engagement_team",
    label: t('engagement_team'),
    className: "ms-2 mt-2",
    onChange: handleIncludeEngagementTeam
  }), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("tbody", {
    "data-testid": "clientContactModalBody"
  }, /*#__PURE__*/React.createElement("tr", {
    className: "text-primary app-fs-table-header"
  }, /*#__PURE__*/React.createElement("th", {
    className: "border-0 font-weight-normal",
    style: {
      width: '20%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between"
  }, /*#__PURE__*/React.createElement("div", null, t('role'))))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      width: '20%'
    }
  }, roles.map(role => {
    return /*#__PURE__*/React.createElement(Form.Check, {
      checked: clientContact.roles.includes(role.value),
      value: role.value,
      name: role.value,
      label: t(role.value),
      onChange: e => handleAddRole(e)
    });
  })))));
}